/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable n/handle-callback-err */
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
    // handle error, e.g. report to a service
  }
})
